module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/orange-grove@3x_84c084.jpg";